import { API_ENDPOINTS } from "@/constants/api";

export interface Invoice {
  id: string;
  invoiceNumber: string | null;
  amount: number;
  amountPaid: number;
  amountDue: number;
  currency: string;
  status: string;
  description: string | null;
  dueDate: string | null;
  paidAt: string | null;
  pdfUrl: string | null;
  hostedInvoiceUrl: string | null;
  createdAt: string;
}

export interface InvoiceListResponse {
  data: Invoice[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export async function getInvoices(
  page: number = 1,
  limit: number = 20,
): Promise<InvoiceListResponse> {
  const res = await fetch(API_ENDPOINTS.INVOICES.LIST(page, limit), {
    credentials: "include",
  });
  if (!res.ok) {
    throw new Error(`Failed to fetch invoices: ${res.status}`);
  }
  return res.json();
}
